<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />

    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/ipage/AboutInstructor.vue'

import TestimonialCompany from '../../components/ipage/CompnayTestimonial.vue'
import Landing from '../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../components/ipage/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import BasicRequirement from '../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../components/ipage/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Your first step towards a ',
        subTitle: 'Flutter Developer',
        paragraph:
          'Upskill presents this assessment only designed for Flutter Developer. Take part in this assessment, and get a chance to work at iPAGE ',
        //   companyLogo: require('../assets/ipage/ipage 1.png'),
        quizLink:
          'https://quiz.upskill.com.bd/assessment/7727cede-8d3b-49e6-a7bb-51539844b672?public=true&job=ipage_flutter_developer',
        landingImage: require('../../assets/telmax/Frame.png'),
        spanColor: 'green',
        logoMobile: false,
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../assets/ipage/ipage 2.png'),
        info:
          'iPAGE is an award-winning Bangladeshi agritech impact startup specializing in deep learning, precision hardware & software technologies, and AI. With a farm to fork concept, the business organization is developing an end-to-end solution to bridge the gap between the production and distribution nodes and addressing the hardships of smallholder farmers and local consumers while cutting down the extra layers of intermediaries. With its homegrown technological intervention, iPAGE envisions to set balance to the demand and supply equation in the agricultural industry of the Global South.',
        designation: '',

        bgColor: '#292B2A',
      },
      programData: {
        headingInfo:
          'Flutter Developer Assessment consists of approximately 15 MCQs. You are required to pass an assessment test with a minimum 60% of the total score. ',
        seatsInfo:
          'Top 5-10 Candidates will get the chance to go to the interview round directly after completing the assessment. So, don’t miss this opportunity as time is limited!',
        startDate: '9th February',
        cost: 'Free',
        deadline: '18th February',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/a0786e2e-d709-4bbb-9877-984dce28b116?public=true&job=job_ipage',
        bgColor: '#1EBCE5',
        txtColor: '#00A653',
      },

      companyTestimonial: {
        mainImg: require('../../assets/ipage/ipage 3.png'),
        name: 'Mashrur H. Shurid ',
        paragraph:
          ' UN-award-winning agri-info-tech startup iPAGE is digitizing Bangladeshi farmers agricultural practices and helping them make the right decision using data & technology. To amp up our impact journey, we are looking for a Flutter Developer. ',
        designation: 'Co-founder & CEO \niPAGE BANGLADESH LIMITED',
        invertedCommaBg: ' #00A653',
      },
      basicRequirement: {
        mainContent: [
          'Bachelor of Science (BSc) in Computer Science Engineering from any reputed university.',
          'At least 2 years of experience in the relevant software industry',
          'Must have at least 1+ years of experience in mobile software development',
          'Sound experience in native and cross-application development',
          'Must have at least 1+ years of experience in Flutter development',
          'Must have completed at least 2 projects for Android or iOS applications using Flutter',
          'Ability to understand business requirements and translate them into technical requirements',
          'Solid understanding of the full mobile development life cycle',
          'Knowledge of modern authorization mechanisms, such as JSON Web Token',
          'Published applications in the Google Play or App Store will be given more priority',
          'Prior experience with GIT',
        ],
        bgColor: '#00a653',
      },

      outlineColor: {
        color: '#00a653',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Yes, a minimum of 2 years of experience in relevant areas(at least 1+ years in mobile software development and at least 1+ years of experience in Flutter development.\n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score ',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at iPAGE?\n',
          content:
            'No, the top 5 students will get a chance to interview at iPAGE  and will get the job depending on their performance in the interview. \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
  },
  created() {
    this.Loaded()
  },
}
</script>
